import React, { useImperativeHandle, useState } from 'react'
import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'
import { GInput } from 'tennders-common/form/components'
import GHref from 'tennders-market/common/components/element/GHref'
import GModal from 'tennders-market/common/components/element/GModal'

type Props = {
  onComplete: (reason : string) => void
}

export type WithdrawModalRef = {
  show: () => void,
  close: () => void
}

const WithdrawModal = React.forwardRef<WithdrawModalRef, Props>((props, ref) => {
  const [show, setShow] = useState(false)
  const { t } = useTranslation()
  const [reason, setReason] = useState('')
  const { onComplete } = props

  useImperativeHandle(ref, () => ({
    show: () => {
      setShow(true)
    },
    close: () => {
      setShow(false)
    }
  }), [])

  const handleSubmit = () => {
    setShow(false)
    onComplete(reason)
  }

  const handleClose = () => {
    setReason('')
    setShow(false)
  }

  return (
    <GModal isOpen={show} close={handleClose}>
      <div className="w-100">
        <div className="p-20">
          <h3 className="bold">
            {t('salesInvoice:withdrawInternalComment')}
          </h3>

          <div className="d-flex row">
            <div className="col">
              <GInput
                style={{ minWidth: 500 }}
                type="textarea"
                val={reason}
                onSet={setReason}
              />
            </div>
          </div>
        </div>
        <div className="hr" />
        <div className="d-flex justify-space">
          <div className="text-12" />
          <GHref
            onClick={handleSubmit}
            className="btn standard-btn   bold confirm-step-btn-2"
          >
            <Trans i18nKey="common:save" />
          </GHref>
        </div>
      </div>
    </GModal>
  )
})

export default WithdrawModal
